<div *ngIf="dsHeader && dsHeader.shw_hdr" class="w-f-d w-full  bg-white border-b">
    <!-- [ngStyle]="{'height': settings.opn_fltrs ? '150px' : 'auto' }" -->
    <div class="grid grid-cols-12 pl-2 py-1 hdrBg">
        <div class="col-span-5">
            <div style="padding-top: 10px;">

                <span class="font-bold pl-4" style="font-size: 17px; color: white;">{{dsHeader.title}}</span>
                <div class="hdr-subtitle pl-4" *ngIf="dsHeader.sub_title">{{dsHeader.sub_title}}</div>
            </div>
        </div>

        <div class="col-span-4 ">
            <div *ngIf="dsHeader['srch_in']" class="hd-search" style="margin-top: 4px;">
                <mat-form-field>
                    <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input matInput [autocomplete]="'off'" [(ngModel)]="fltr_keys.inpt_srch_txt"
                        [placeholder]="dsHeader.srch_ph_tx" (keyup)="entrStchTxt()">
                    <button mat-icon-button matSuffix>
                        <mat-icon [svgIcon]="'heroicons_solid:x-circle'" (click)="clrInptSrchTxt()"></mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>

        <div class="col-span-1 text-right mr-4 m-auto">
            <button mat-icon-button (click)="openFltrs()" *ngIf="dsHeader.shw_fltr" class="bg-indigo-500 cstmFltrBtn">
                <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="filter_alt"
                    class="cls-icn-clr"></mat-icon>
            </button>
        </div>
        <div class="col-span-2 text-right mr-4 m-auto">


            <button type="button" (click)="navgtBack()" *ngIf="dsHeader.shw_bck_btn_in"
                class="mt-2 text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg  px-3 py-1 text-center me-2 mb-2 dark:border-purple-400 dark:text-purple-400 dark:hover:text-white dark:hover:bg-purple-500 dark:focus:ring-purple-900">
                <mat-icon class="shadow-2xl  text-purple-500" svgIcon="mat_outline:arrow_back_ios"
                    style="vertical-align: middle; height:15px;min-height:15px"></mat-icon>
                Back
            </button>

            <button type="button" (click)="refresh()" *ngIf="dsHeader.shw_refresh_in"
                class="mt-2 text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg  px-3 py-1 text-center me-2 mb-2 dark:border-purple-400 dark:text-purple-400 dark:hover:text-white dark:hover:bg-purple-500 dark:focus:ring-purple-900">
                <mat-icon class="shadow-2xl  text-purple-500" svgIcon="mat_outline:refresh"
                    style="vertical-align: middle; height:15px;min-height:15px"></mat-icon>
                Refresh
            </button>


            <!-- <button class="ml-3  bg-purple-500 rounded-full"  mat-flat-button [color]="'primary'"  style="    height: 34px;
            min-height: 34px;;">
                <mat-icon [svgIcon]="'heroicons_outline:chevron-left'" class="bckBtnIcn"></mat-icon>
                <span class="ml-2 mr-1">Back</span>
            </button> -->


        </div>


    </div>


    <div *ngIf="settings.opn_fltrs">
        <div class="fltrSec border-t py-2 px-4">
            <div class="sm-input">
                <div class="grid grid-cols-12 gap-2" style="margin-top: 0px; margin-bottom: 0px;">
                    <div class="col-span-2" *ngIf="showFilter('fltr_states')">
                        <div *ngIf="data.stateLst.length == 0 || data.stateLst.length > 1">
                            <label class="f-lbl">State</label><br>
                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.ste_id" (selectionChange)="getDistricts()">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.stateLst;"
                                        [value]="p.ste_id">{{p.ste_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.stateLst.length == 1">
                            <div class="f-lbl">State</div>
                            <div class="slctd-fltr">{{fltr_keys.ste_nm}}</div>
                        </div>



                    </div>
                    <div class="col-span-2" *ngIf="showFilter('fltr_district')">
                        <div *ngIf="data.districtLst.length == 0 || data.districtLst.length > 1">
                            <label class="f-lbl">District </label><br>

                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.dstrt_id" (selectionChange)="getMandals()">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.districtLst;"
                                        [value]="p.dstrt_id">{{p.dstrt_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.districtLst.length == 1">
                            <div class="f-lbl">District</div>
                            <div class="slctd-fltr">{{fltr_keys.dstrt_nm}}</div>
                        </div>
                    </div>



                    <div class="col-span-2" *ngIf="showFilter('fltr_cnstncy')">
                        <div *ngIf="data.ConstuencyLst.length == 0 || data.ConstuencyLst.length > 1">
                            <label class="f-lbl">Constituency </label><br>

                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.cnsty_id" (selectionChange)="getMandals()" disabled>
                                    <mat-option *ngFor="let p of data.ConstuencyLst;"
                                        [value]="p.dstrt_id">{{p.dstrt_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.districtLst.length == 1">
                            <div class="f-lbl">Constituency</div>
                            <div class="slctd-fltr">{{fltr_keys.dstrt_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_mandal')">
                        <div *ngIf="data.mandalsLst.length == 0 || data.mandalsLst.length > 1">
                            <label class="f-lbl">Mandal/ULB</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.mndl_id" (selectionChange)="getSvmLst()">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.mandalsLst;"
                                        [value]="p.mndl_id">{{p.mndl_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.mandalsLst.length == 1">
                            <div class="f-lbl">Mandal</div>
                            <div class="slctd-fltr">{{fltr_keys.mndl_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_sachivalayam')">
                        <div *ngIf="data.svm_lst.length == 0 || data.svm_lst.length > 1">
                            <label class="f-lbl">Sachivalayam Name</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.svm_id">
                                    <mat-option [value]="null" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.svm_lst"
                                        [value]="p.svm_id">{{p.svm_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.svm_lst.length == 1">
                            <div class="f-lbl">Sachivalayam Name</div>
                            <div class="slctd-fltr">{{fltr_keys.svm_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_ward')">
                        <div *ngIf="data.wrdsLst.length == 0 || data.wrdsLst.length > 1">
                            <label class="f-lbl">Ward Name</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.wrd_id">
                                    <mat-option [value]="null" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let k of data.wrdsLst"
                                        [value]="k.wrd_id">{{k.wrd_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.wrdsLst.length == 1">
                            <div class="f-lbl">Ward Name</div>
                            <div class="slctd-fltr">{{fltr_keys.wrd_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_wrkctgry')">
                        <div *ngIf="data.wrkTypLsts.length == 0 || data.wrkTypLsts.length > 1">
                            <label class="f-lbl">Work Category</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.wrk_type_id" (selectionChange)="getSubWorkType()">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let s of data.wrkTypLsts"
                                        [value]="s.wrk_type_id">{{s.wrk_type_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.wrkTypLsts.length == 1">
                            <div class="f-lbl">Work Category</div>
                            <div class="slctd-fltr">{{fltr_keys.wrk_type_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_sbwrk_ctgry')">
                        <div *ngIf="data.wrkSubTypLst.length == 0 || data.wrkSubTypLst.length > 1">
                            <label class="f-lbl">Sub Category</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.sb_wrk_type_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.wrkSubTypLst"
                                        [value]="p.sb_wrk_type_id">{{p.sb_wrk_type_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.wrkSubTypLst.length == 1">
                            <div class="f-lbl">Sub Category</div>
                            <div class="slctd-fltr">{{fltr_keys.sb_wrk_type_nm}}</div>
                        </div>
                    </div>
                    <div class="col-span-2" *ngIf="showFilter('fltr_file_type')">
                        <div *ngIf="data.fType.length == 0 || data.fType.length > 1">
                            <label class="f-lbl">File Type</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.tckt_ctgry_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.fType"
                                        [value]="p.tckt_ctgry_id">{{p.tckt_ctgry_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.fType.length == 1">
                            <div class="f-lbl">File Type</div>
                            <div class="slctd-fltr">{{fltr_keys.tckt_ctgry_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_main_stg')">
                        <div *ngIf="data.mStages.length == 0 || data.mStages.length > 1">
                            <label class="f-lbl">Main Stages</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.stge_mstr_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.mStages"
                                        [value]="p.stge_mstr_id">{{p.stge_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.mStages.length == 1">
                            <div class="f-lbl">Main Stages</div>
                            <div class="slctd-fltr">{{fltr_keys.stge_nm}}</div>
                        </div>
                    </div>
                    <div class="col-span-2" *ngIf="showFilter('fltr_min_amnt')">
                        <label class="inptLbl">Sanctioned Amount From&nbsp;<span
                                class="text-red-600">*</span></label><br>
                        <mat-form-field appearance="fill">
                            <input matInput placeholder="" [(ngModel)]="fltr_keys.min_sn_at">
                        </mat-form-field>
                    </div>
                    <div class="col-span-2" *ngIf="showFilter('fltr_max_amnt')">
                        <label class="inptLbl">Sanctioned Amount To&nbsp;<span class="text-red-600">*</span></label><br>
                        <mat-form-field appearance="fill">
                            <input matInput placeholder="" [(ngModel)]="fltr_keys.mx_sn_at">
                        </mat-form-field>
                    </div>

                    <div class="col-span-2" *ngIf="showFilter('fltr_dsgns')">
                        <div *ngIf="data.dsgnsLst.length == 0 || data.dsgnsLst.length > 1">
                            <label class="f-lbl">Designation</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.dsgns_id">
                                    <!-- <mat-option [value]="null" *ngIf="settings.shw_all_sclt">ALL</mat-option> -->
                                    <mat-option *ngFor="let k of data.dsgnsLst"
                                        [value]="k.dsgns_id">{{k.dsgns_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.dsgnsLst.length == 1">
                            <div class="f-lbl">Designation</div>
                            <div class="slctd-fltr">{{fltr_keys.dsgns_id}}</div>
                        </div>
                    </div>


                    <div class="col-span-2" *ngIf="showFilter('fltr_asgn_emp')">
                        <div *ngIf="data.employees.length == 0 || data.employees.length > 1">
                            <label class="f-lbl">Assign Employee</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.assgn_empl_id">
                                    <!-- <mat-option [value]="null" *ngIf="settings.shw_all_sclt">ALL</mat-option> -->
                                    <mat-option *ngFor="let k of data.employees" [value]="k.usr_id">{{ k.fst_nm}} - {{
                                        k.mble_ph }} -
                                        {{ k.dsgns_nm }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.employees.length == 1">
                            <div class="f-lbl">Assign Employee</div>
                            <div class="slctd-fltr">{{fltr_keys.assgn_empl_id}}</div>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_gp')">
                        <div *ngIf="data.GPLst.length == 0 || data.GPLst.length > 1">


                            <label class="f-lbl">Grama Panchayat </label><br>
                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.gp_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.GPLst;" [value]="p.gp_id">{{p.gp_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div *ngIf="data.GPLst.length == 1">
                            <div class="f-lbl">Grama Panchayat</div>
                            <div class="slctd-fltr">{{fltr_keys.gp_nm}}</div>
                        </div>

                    </div>


                    <div class="col-span-3" *ngIf="showFilter('fltr_habitation')">
                        <div *ngIf="data.habitationlist.length == 0 || data.habitationlist.length > 1">



                            <label class="f-lbl">Habitation</label><br>
                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.hbtn_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.habitationlist;"
                                        [value]="p.hbtn_id">{{p.hbtn_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.habitationlist.length == 1">
                            <div class="f-lbl"> Habitation</div>
                            <div class="slctd-fltr">{{fltr_keys.hbtn_nm}}</div>
                        </div>

                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_work_type')">

                        <div *ngIf="data.wrkTypLst.length == 0 || data.wrkTypLst.length > 1">


                            <label class="f-lbl">Work Type</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.wrk_type_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.wrkTypLst;"
                                        [value]="p.wrk_type_id">{{p.wrk_type_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div *ngIf="data.wrkTypLst.length == 1">
                            <div class="f-lbl">Work Type</div>
                            <div class="slctd-fltr">{{fltr_keys.wrk_type_nm}}</div>
                        </div>

                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_work_sub_type')">

                        <div *ngIf="data.wrkSubTypLst.length == 0 || data.wrkSubTypLst.length > 1">

                            <label class="f-lbl">Work Subtype</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.sb_wrk_type_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.wrkTypLst;"
                                        [value]="p.sb_wrk_type_id">{{p.sb_wrk_type_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>


                        <div *ngIf="data.wrkSubTypLst.length == 1">
                            <div class="f-lbl">Work Subtype</div>
                            <div class="slctd-fltr">{{fltr_keys.sb_wrk_type_nm}}</div>
                        </div>

                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_work_nature')">
                        <div *ngIf="data.wrkNtreLst.length == 0 || data.wrkNtreLst.length > 1">

                            <label class="f-lbl">Work Nature</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.wrk_ntre_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.wrkNtreLst;"
                                        [value]="p.wrk_ntre_id">{{p.wrk_ntre_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                        <div *ngIf="data.wrkNtreLst.length == 1">
                            <div class="f-lbl">Work Nature</div>
                            <div class="slctd-fltr">{{fltr_keys.wrk_ntre_nm}}</div>
                        </div>

                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_work_status')">
                        <div *ngIf="data.wrkstatusLst.length == 0 || data.wrkstatusLst.length > 1">

                            <label class="f-lbl">Work status</label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.wrk_sts_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.wrkstatusLst;"
                                        [value]="p.wrk_sts_id">{{p.wrk_sts_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                        <div *ngIf="data.wrkstatusLst.length == 1">
                            <div class="f-lbl">Work Status</div>
                            <div class="slctd-fltr">{{fltr_keys.wrk_sts_nm}}</div>
                        </div>

                    </div>

                    <div class="col-span-3" *ngIf="showFilter('ast_ctgry_id')">
                        <div *ngIf="data.categories.length == 0 || data.categories.length > 1">
                            <label class="inptLbl">Asset Category&nbsp;<span class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.ast_ctgry_id"
                                    (selectionChange)="getCategoryGrp($event)">
                                    <mat-option *ngFor="let d of data.categories"
                                        [value]="d.ast_ctgry_id">{{d.ast_ctgry_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.categories.length == 1">
                            <div class="inptLbl">Asset Category&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.ast_ctgry_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="flag && showFilter('ast_ctgry_id')">
                        <div *ngIf="data.groups.length == 0 || data.groups.length > 1">
                            <label class="inptLbl">{{catgryGrp}}&nbsp;<span class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.ast_grp_id"
                                    (selectionChange)="getCategoryGrp($event)">
                                    <mat-option *ngFor="let d of data.groups"
                                        [value]="d.ast_grp_id">{{d.ast_grp_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.groups.length == 1">
                            <div class="inptLbl">{{catgryGrp}}&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.ast_grp_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="flag && showFilter('ast_type_id')">
                        <div *ngIf="data.types.length == 0 || data.types.length > 1">
                            <label class="inptLbl">{{catType}}&nbsp;<span class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.ast_type_id"
                                    (selectionChange)="getCategoryGrp($event)">
                                    <mat-option *ngFor="let d of data.types"
                                        [value]="d.ast_type_id">{{d.ast_type_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.types.length == 1">
                            <div class="inptLbl">{{catType}}&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.ast_type_nm}}</div>
                        </div>
                    </div>


                    <div class="col-span-3" *ngIf="flag && showFilter('ast_cd')">

                        <label class="inptLbl">{{catAsstCode}}&nbsp;<span class="text-red-600">*</span></label><br>
                        <mat-form-field appearance="fill">
                            <input matInput placeholder="" formControlName="ast_cd">
                        </mat-form-field>

                    </div>

                    <div class="col-span-3" *ngIf="flag && showFilter('vndr_ast_cd')">

                        <label class="inptLbl">{{catAsstVndrCode}}&nbsp;<span class="text-red-600">*</span></label><br>
                        <mat-form-field appearance="fill">
                            <input matInput placeholder="" formControlName="vndr_ast_cd">
                        </mat-form-field>

                    </div>



                    <div class="col-span-3" *ngIf="showFilter('fltr_prtlSte')">
                        <div *ngIf="data.site_lst.length == 0 || data.site_lst.length > 1">
                            <label class="inptLbl">Web Portals&nbsp;<span class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.prvdr_ste_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let d of data.site_lst"
                                        [value]="d.prvdr_ste_id">{{d.ste_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.site_lst.length == 1">
                            <div class="inptLbl">Web Portals&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.ste_nm}}</div>
                        </div>
                    </div>


                    <div class="col-span-3" *ngIf="showFilter('fltr_imprtLnks')">
                        <div *ngIf="data.links_lst.length == 0 || data.links_lst.length > 1">
                            <label class="inptLbl">Links Category&nbsp;<span class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.glry_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let d of data.links_lst"
                                        [value]="d.glry_id">{{d.glry_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.site_lst.length == 1">
                            <div class="inptLbl">Links Category&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.glry_nm}}</div>
                        </div>
                    </div>


                    <div class="col-span-3" *ngIf="showFilter('fltr_docCtgry')">
                        <div *ngIf="data.docCtgry_lst.length == 0 || data.docCtgry_lst.length > 1">
                            <label class="inptLbl">Document Category&nbsp;<span
                                    class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.doc_glry_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let d of data.docCtgry_lst"
                                        [value]="d.glry_id">{{d.glry_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.site_lst.length == 1">
                            <div class="inptLbl">Document Category&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.glry_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_pgEdt')">
                        <div *ngIf="data.glryLst.length == 0 || data.glryLst.length > 1">
                            <label class="inptLbl">Select Contact Page&nbsp;<span
                                    class="text-red-600">*</span></label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.cntct_glry_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let d of data.glryLst"
                                        [value]="d.glry_id">{{d.glry_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.site_lst.length == 1">
                            <div class="inptLbl">Contact Page&nbsp;<span class="text-red-600">*</span></div>
                            <div class="slctd-fltr">{{fltr_keys.glry_nm}}</div>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_sectors')">
                        <div *ngIf="data.sctrsLst.length == 0 || data.sctrsLst.length > 1">


                            <label class="f-lbl">Sectors </label><br>
                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.sctr_id" (selectionChange)="getSchmsLst()">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.sctrsLst;"
                                        [value]="p.sctr_id">{{p.sctr_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.sctrsLst.length == 1">
                            <div class="f-lbl">Sector</div>
                            <div class="slctd-fltr">{{fltr_keys.sctr_nm}}</div>
                        </div>
                    </div>


                    <div class="col-span-3" *ngIf="showFilter('fltr_schme')">
                        <div *ngIf="data.schmsLst.length == 0 || data.schmsLst.length > 1">


                            <label class="f-lbl">Scheme </label><br>
                            <mat-form-field appearance="fill">

                                <mat-select [(ngModel)]="fltr_keys.schme_id">
                                    <mat-option value="0" *ngIf="settings.shw_all_sclt">ALL</mat-option>
                                    <mat-option *ngFor="let p of data.schmsLst;"
                                        [value]="p.schme_id">{{p.schme_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                        <div *ngIf="data.schmsLst.length == 1">
                            <div class="f-lbl">Scheme</div>
                            <div class="slctd-fltr">{{fltr_keys.schme_nm}}</div>
                        </div>



                    </div>




                    <div class="col-span-3" *ngIf="showFilter('fltr_trnch')">
                        <div *ngIf=" data.trnchLst && (data.trnchLst.length == 0 || data.trnchLst.length > 1)">
                            <label class="f-lbl">Trench </label><br>
                            <mat-form-field appearance="fill">
                                <mat-select [(ngModel)]="fltr_keys.ln_trnch_id">
                                    <mat-option *ngFor="let p of data.trnchLst;"
                                        [value]="p.ln_trnch_id">{{p.ln_trnch_nm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <div *ngIf="data.trnchLst.length == 1">
                            <div class="f-lbl">Trench </div>
                            <div class="slctd-fltr">{{fltr_keys.ln_trnch_nm}}</div>
                        </div>


                    </div>



                    <div class="col-span-3" *ngIf="showFilter('fltr_fromdate')">
                        <div>
                            <label class="f-lbl">Choose from date (MM/DD/YYYY)</label><br>
                            <mat-form-field>
                                <input matInput [matDatepicker]="picker" [(ngModel)]="fltr_keys.frm_dt">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-span-3" *ngIf="showFilter('fltr_todate')">
                        <div>
                            <label class="f-lbl">Choose to date (MM/DD/YYYY)</label><br>
                            <mat-form-field>
                                <input matInput [matDatepicker]="picker2" [(ngModel)]="fltr_keys.to_dt">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>




                    <div class="col-span-2  aplyBtn">
                        <button mat-flat-button (click)="getFiltrData()">Apply Filters</button>
                    </div>


                </div>
            </div>

        </div>


        <!-- <div class="flex items-center py-2 space-x-2 justify-between" style="Padding:10px;">
            <div class="col-10  brdcrumbStyls">
                <ul>
                    <li>ANDHRA PRADESH<br />
                        <div class="brd-db-txt">STATE</div>
                    </li>
                   
                    <li>District Name<br />
                        <div class="brd-db-txt">DISTRICT</div>
                    </li>
                    <li >ULB Name<br />
                        <div class="brd-db-txt">ULB</div>
                    </li>
                   
                </ul>
            </div>
      
            <div 
                class="col-2" style="text-align: right;">
          
                <button type="button" 
                    class="text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg  px-3 py-1 text-center me-2 mb-2 dark:border-purple-400 dark:text-purple-400 dark:hover:text-white dark:hover:bg-purple-500 dark:focus:ring-purple-900">
                    <mat-icon class="shadow-2xl  text-purple-500" svgIcon="mat_outline:arrow_back_ios"
                        style="vertical-align: middle; height:15px;min-height:15px"></mat-icon>
                    Back
                </button>
              
            </div>
        </div> -->

    </div>






















</div>